import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import OtpInput from "react-otp-input";
import styles from "./OTPScreenV2.module.scss";
import { HeroImage } from "../LoginV2/HeroImage";
import logo from "../../public/logo.png";
import config from "../../config";
import { otpscreen } from "../../Redux/actions/actionCreator/data.action";
import { useTranslation } from "react-i18next";
import LanguageSelect from "../LanguageSelection";
import { DotLoader } from "../common/DotLoader";

export const OTPScreenV2 = () => {
  const [otp, setotp] = useState("");
  const [loading, setloading] = useState(false);
  const [errr, setErr] = useState("");
  const [err, seterr] = useState("");
  const [redirect, setredirect] = useState("");
  const [resendButtonDisabledTime, setResendButtonDisabledTime] = useState(30);
  const otpInputRef = useRef(null);

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const token = useSelector((state) => state.token._id);
  const mob = useSelector((state) => state.token.mob);

  let resendOtpTimerInterval;

  const startResendOtpTimer = () => {
    if (resendOtpTimerInterval) {
      clearInterval(resendOtpTimerInterval);
    }
    resendOtpTimerInterval = setInterval(() => {
      if (resendButtonDisabledTime <= 0) {
        clearInterval(resendOtpTimerInterval);
      } else {
        setResendButtonDisabledTime(resendButtonDisabledTime - 1);
      }
    }, 1000);
  };

  useEffect(() => {
    startResendOtpTimer();

    return () => {
      if (resendOtpTimerInterval) {
        clearInterval(resendOtpTimerInterval);
      }
    };
  }, [resendButtonDisabledTime]);

  // Auto-focus OTP input on mount
  useEffect(() => {
    if (otpInputRef.current) {
      const firstInput = otpInputRef.current.querySelector('input');
      if (firstInput) {
        firstInput.focus();
      }
    }
  }, [loading]);

  const otpjoin = (otp) => {
    setotp(otp);
    if (otp.length === 4) {
      validateotp(otp);
    }
  };

  const validateotp = (otp) => {
    console.log("pin in validate", otp);
    let pin = parseInt(otp, 10);
    let resok = true;
    setloading(true);

    fetch(`${config.devurl}/verifyDaycareOTP`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id: token, otp: pin }),
    })
      .then((res) => {
        resok = res.ok;
        return res.json();
      })
      .then((data) => {
        console.log("data email in forgot password", data);

        if (resok) {
          setredirect("reset");
          setotp("");
          setTimeout(() => {
            setloading(false);
          }, 1000);
        } else {
          if (data.DaycareManager) {
            seterr(data.error);
          } else if (data.message) {
            setErr(data.message);
          }
          // Clear OTP and refocus on error
          setotp("");
          setTimeout(() => {
            setloading(false);
            // Focus the first input after clearing
            if (otpInputRef.current) {
              const firstInput = otpInputRef.current.querySelector('input');
              if (firstInput) {
                firstInput.focus();
              }
            }
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("error", error);
        setloading(false);
        seterr(t("otp_verification_failed") || "OTP verification failed");
        // Clear OTP and refocus on error
        setotp("");
        if (otpInputRef.current) {
          const firstInput = otpInputRef.current.querySelector('input');
          if (firstInput) {
            firstInput.focus();
          }
        }
      });
  };

  const onResendOtpButtonPress = () => {
    Resendotp();
  };

  const delfn = () => {
    let data = {
      _id: "",
      mobile: "",
    };
    dispatch(otpscreen(data));
  };

  const Resendotp = () => {
    let resok = true;
    fetch(`${config.devurl}/resendOTP`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id: token }),
    })
      .then((res) => {
        resok = res.ok;
        return res.json();
      })
      .then((data) => {
        console.log("data resend OTP", data);
        if (resok) {
          setResendButtonDisabledTime(30);
          startResendOtpTimer();
          if (data.DaycareManager) {
            let times =( 6 - data.DaycareManager.resendFrequency) || 0;
            let msg = `You have ${times} tries left`;
            setErr(msg);
            seterr("");
          }
        } else {
          seterr(data.error);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  if (token) {
    if (redirect === "reset") {
      return <Redirect to="/user/resetpassword" />;
    } else {
      return (
        <div className={styles["otp-container"]}>
          <div className={styles["hero-section"]}>
            <div className={styles.illustration}>
              <HeroImage />
            </div>
          </div>

          <div className={styles["form-section"]}>
            <div style={{ position: "absolute", top: 0, right: 0 }}>
              <LanguageSelect />
            </div>
            <div className={styles["form-container"]}>
              <div className={styles.logo}>
                <img
                  src={logo}
                  alt="Stepswatch logo"
                  className={styles.logoImage}
                />
              </div>

              {loading ? (
                <div className={styles["loading-container"]}>
                  <DotLoader />
                  <p className={styles["loading-text"]}>
                    {t("verifying") || "Verifying..."}
                  </p>
                </div>
              ) : (
                <>
                  <h2 className={styles["welcome-title"]}>
                    {t("verify_mobile_number")}
                  </h2>
                  <p className={styles.subtitle}>
                    {t("otp_sent_message")} ********
                    {mob ? mob.toString().slice(11, 13) : null}
                  </p>

                  <div className={styles["otp-input-container"]} ref={otpInputRef}>
                    <OtpInput
                      inputStyle={{
                        width: "60px",
                        height: "60px",
                        margin: "0 8px",
                        fontSize: "24px",
                        borderRadius: "8px",
                        border: "2px solid #e0e0e0",
                        textAlign: "center",
                      }}
                      focusStyle={{
                        border: "2px solid rgb(63, 81, 181)",
                        outline: "none",
                      }}
                      value={otp}
                      onChange={(e) => otpjoin(e)}
                      numInputs={4}
                      isInputNum={true}
                      shouldAutoFocus={true}
                    />
                  </div>
                  {err && <p className={styles["error-message"]}>{err}</p>}
                  {errr && <p className={styles["error-message"]}>{errr}</p>}
                  <div className={styles["resend-section"]}>
                    <p className={styles["resend-text"]}>
                      {t("didnt_receive_otp")}
                    </p>
                    {resendButtonDisabledTime > 0 ? (
                      <p className={styles["timer-text"]}>
                        {t("resend_otp_in")} {resendButtonDisabledTime}{" "}
                        {t("seconds")}...
                      </p>
                    ) : (
                      <div className={styles["action-buttons"]}>
                        <button
                          className={styles["resend-button"]}
                          onClick={() => onResendOtpButtonPress()}
                        >
                          {t("resend")}
                        </button>
                        {/* <button
                          className={styles["change-number-button"]}
                          onClick={() => delfn()}
                        >
                          {t("change_number")}
                        </button> */}
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      );
    }
  } else {
    return <Redirect to="/" />;
  }
};

export default OTPScreenV2;
